import React from 'react';

import { TableRow } from '../ControlTab/utils';
import { DataTableColumn } from '@/components/DataTable';

export const createLubeColumns = (
  StatusIndicatorComponent: React.ComponentType<{ status: '0' | '1' }>
): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    needPadding: row =>
      row.value !== '0' && row.value !== '1' && row.unit !== '',
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      if ((row.value === '0' || row.value === '1') && row.unit === '') {
        return <StatusIndicatorComponent status={row.value as '0' | '1'} />;
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if ((row.value === '0' || row.value === '1') && row.unit === '') {
        return null;
      }
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
      return null;
    }
  }
];

export const createLubeRows = (initialData: any): TableRow[] => {
  if (!initialData?.mode || !Array.isArray(initialData.mode)) return [];
  return initialData.mode as TableRow[];
};
